import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function NotFound() {
  return (
    <div data-testid="notfound-page" className="max-w-3xl mx-auto px-6 py-32 text-center">
      <p className="section-num inline-flex">
        <strong>·</strong> 404
      </p>
      <h1 className="font-display text-display-lg text-ink mt-5 tracking-tightest">
        This page got
        <br />
        <span className="font-italic text-coral">composted.</span>
      </h1>
      <p className="mt-6 text-ink/65 leading-relaxed max-w-md mx-auto">
        Nothing here — but everything else is just one click away.
      </p>
      <Link to="/" className="btn-primary mt-10">
        <ArrowLeft className="h-4 w-4" /> Back home
        <span className="knob">→</span>
      </Link>
    </div>
  );
}
